module.exports = __webpack_public_path__ + "static/media/sygnet-appartme-fiolet.62d4bb20.svg";